import * as CONSTANST from '../../constants';
export default {

    /**
     * Indicates that the availability data is being fetched.
     *
     * @param state
     */
    [CONSTANST.DASHBOARD_AVAILABILITY_PENDING] (state) {
        state.availability = {...state.availability, loading: true, error: false, noContent: false, items: undefined}
    },

    /**
     * Indicates that the availability data was fetched successfully.
     *
     * @param state
     * @param payload
     */
    [CONSTANST.DASHBOARD_AVAILABILITY_SUCCESS] (state, payload) {
        state.availability = {...state.availability, loading: false, error: false, noContent: false, items: payload}
    },

    /**
     * Indicates that the availability data was fetched unsuccessfully.
     *
     * @param state
     */
    [CONSTANST.DASHBOARD_AVAILABILITY_FAILURE] (state) {
        state.availability = {...state.availability, loading: false, error: true, noContent: false, items: undefined}
    },

    /**
     * Inidcates that there were no availability data.
     *
     * @param state
     */
    [CONSTANST.DASHBOARD_AVAILABILITY_NO_CONTENT] (state) {
        state.availability = {...state.availability, loading: false, error: false, noContent: true, items: undefined}
    },

    /**
     * Indicates that the notification data is being fetched.
     *
     * @param state
     */
    [CONSTANST.DASHBOARD_NOTIFICATIONS_PENDING] (state) {
        state.notifications = {...state.notifications, loading: true, error: false, noContent: false, items: undefined}
    },

    /**
     * Indicates that the notification data was successfully fetched.
     *
     * @param state
     * @param payload
     */
    [CONSTANST.DASHBOARD_NOTIFICATIONS_SUCCESS] (state, payload) {
        state.notifications = {...state.notifications, loading: false, error: false, noContent: false, items: payload}
    },

    /**
     * Indicates that the notification data was fetched unsuccessfully.
     *
     * @param state
     */
    [CONSTANST.DASHBOARD_NOTIFICATIONS_FAILURE] (state) {
        state.notifications = {...state.notifications, loading: false, error: true, noContent: false, items: undefined}
    },

    /**
     * Indicates that there were no notifications data.
     *
     * @param state
     */
    [CONSTANST.DASHBOARD_NOTIFICATIONS_NO_CONTENT] (state) {
        state.notifications = {...state.notifications, loading: false, error: false, noContent: true, items: undefined}
    },

    /**
     * Set the accommodations notification filters.
     *
     * @param state
     * @param payload
     */
    [CONSTANST.DASHBOARD_NOTIFICATIONS_FILTERS_SET] (state, payload) {
        state.notifications.filters = {...state.notifications.filters, ...payload.data};
    },

    /**
     * Resets the accommodation notifications page.
     *
     * @param state
     */
    [CONSTANST.DASHBOARD_NOTIFICATIONS_PAGE_RESET] (state) {
        state.notifications.page = 1;
    },

    /**
     * Increment the accommodation notification page.
     *
     * @param state
     */
    [CONSTANST.DASHBOARD_NOTIFICATIONS_PAGE_INCREMENT] (state) {
        state.notifications.page++;
    },

    /**
     * Decrement the accommodation notification page.
     *
     * @param state
     */
    [CONSTANST.DASHBOARD_NOTIFICATIONS_PAGE_DECREMENT] (state) {
        state.notifications.page--;
    },

    /**
     * Sets the accommodation notification page limit.
     *
     * @param state
     * @param payload
     */
    [CONSTANST.DASHBOARD_NOTIFICATIONS_LIMIT_SET] (state, payload) {
        state.notifications.limit = payload;
    },

    /**
     * Indicates that the notification dismissal is pending.
     *
     * @param state
     */
    [CONSTANST.DASHBOARD_NOTIFICATIONS_DISMISS_PENDING] (state) {
        state.notifications.dismiss = {...state.notifications.dismiss, loading: true, error: false, noContent: false,}
    },

    /**
     * Indicates that the notification dismissal succeeded.
     *
     * @param state
     */
    [CONSTANST.DASHBOARD_NOTIFICATIONS_DISMISS_SUCCESS] (state) {
        state.notifications.dismiss = {...state.notifications.dismiss, loading: false, error: false, noContent: false}
    },

    /**
     * Indicates that the notification dismissal failed.
     *
     * @param state
     */
    [CONSTANST.DASHBOARD_NOTIFICATIONS_DISMISS_FAILURE] (state) {
        state.notifications.dismiss = {...state.notifications.dismiss, loading: false, error: true, noContent: false};
    },

    /**
     * Indicates that the notification dismissal had no content.
     *
     * @param state
     */
    [CONSTANST.DASHBOARD_NOTIFICATIONS_DISMISS_NO_CONTENT] (state) {
        state.notifications.dismiss = {...state.notifications.dismiss, loading: false, error: false, noContent: true}
    },

    /**
     * Sets the accommodation availability selected id.
     *
     * @param state
     * @param payload
     */
    [CONSTANST.DASHBOARD_AVAILABILITY_ACCOMMODATION_SET] (state, payload) {
        state.availability.accommodation = payload.data;
    },

    /**
     * Indicates that the supplier list is pending.
     *
     * @param state
     */
    [CONSTANST.DASHBOARD_SUPPLIERS_PENDING] (state) {
        state.suppliers = {...state.suppliers, loading: true, error: false, noContent: false, suppliers: undefined};
    },

    /**
     * Indicates that the supplier list was successfully fetched.
     *
     * @param state
     * @param payload
     */
    [CONSTANST.DASHBOARD_SUPPLIERS_SUCCESS] (state, payload) {
        state.suppliers = {...state.suppliers, loading: false, error: false, noContent: false, suppliers: payload, supplier: payload[0]};
    },

    /**
     * Indicates that the supplier list was unsuccessfully fetched.
     *
     * @param state
     */
    [CONSTANST.DASHBOARD_SUPPLIERS_FAILURE] (state) {
        state.suppliers = {...state.suppliers, loading: false, error: true, noContent: false, suppliers: undefined};
    },

    /**
     * Indicates that the supplier list return no results.
     *
     * @param state
     */
    [CONSTANST.DASHBOARD_SUPPLIERS_NO_CONTENT] (state) {
        state.suppliers = {...state.suppliers, loading: false, error: false, noContent: true, suppliers: undefined};
    },

    /**
     * Set supplier.
     *
     * @param state
     * @param payload
     */
    [CONSTANST.DASHBOARD_SUPPLIER_SET] (state, payload) {
        state.suppliers.supplier = payload;
    },

    /**
     * Reset the dashboard state.
     *
     * @param state
     */
    [CONSTANST.DASHBOARD_RESET_STATE] (state) {
        state.suppliers = {...state.suppliers, loading: false, error: false, noContent: false, supplier: undefined, suppliers: undefined};
        state.availability = {...state.availability, loading: false, error: false, noContent: false, items: undefined, accommodation: undefined};
        state.notifications = {...state.notifications, page: 1, limit: 5, limits: [5,10,20,50], loading: false, error: false, noContent: false, items: undefined};
        state.notifications.filters = {...state.notifications.filters, site: undefined, accommodation: undefined, predicate: undefined, predicates: ['soldOut','stay','arrival','released']};
        state.dismiss = {...state.dismiss, loading: false, error: false, noContent: false}
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/mutations.js